import { useEffect, useMemo, useState } from 'react';
import {
  getGLTemplateCategories,
  getGLTemplateTransactionTypes,
  getGLTemplateTypes,
} from '../../../api/glTemplate';
import { Layout } from '../../../common/components';
import { useSetLoading } from '../../../common/hooks/appearance';
import { apiErrorHandler } from '../../../utils/handlers';
import GLTemplateForm from './GLTemplateForm';
import GLTemplateListingTable from './GLTemplateListingTable';

const GLTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [glTypesData, setGLTypesData] = useState([]);
  const [glCategoriesData, setGLCategoriesData] = useState([]);
  const [glTransactionTypesData, setGlTransactionTypesData] = useState([]);
  const [editingTemplate, setEditingTemplate] = useState(null);

  const handleEditTemplate = (data) => {
    setShowForm((s) => !s);
    setEditingTemplate(data);
  };

  const fetchGLFieldsData = async () => {
    setLoading(true);
    try {
      const typesResp = await getGLTemplateTypes();
      const categoriesResp = await getGLTemplateCategories();
      const transactionsTypesResp = await getGLTemplateTransactionTypes();

      const typesFormatedResp = typesResp.data.data.map((d) => ({
        value: d.TemplateTypeId,
        label: d.name,
      }));
      const categoriesFormatedResp = categoriesResp.data.data.map((d) => ({
        value: d.TemplateCategoryId,
        label: d.name,
      }));

      setGlTransactionTypesData(transactionsTypesResp.data.data);
      setGLTypesData(typesFormatedResp);
      setGLCategoriesData(categoriesFormatedResp);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      apiErrorHandler(err);
    }
  };

  useEffect(() => {
    fetchGLFieldsData();
  }, []);

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  let pageHeading = 'GL Template Search';
  if (showForm) pageHeading = 'New GL Template';
  if (showForm && editingTemplate) pageHeading = 'Edit GL Template';

  return (
    <Layout>
      <div className="atd-div">
        <div className="atd-block mt-4">
          <h4 className="atd-block-heading">{pageHeading}</h4>
          {showForm ? (
            <GLTemplateForm
              onCancel={() => handleEditTemplate(null)}
              editingTemplate={editingTemplate}
              glTypesData={glTypesData}
              glCategoriesData={glCategoriesData}
              glTransactionTypesData={glTransactionTypesData}
              onCreateEditSuccess={() => handleEditTemplate(null)}
            />
          ) : (
            <GLTemplateListingTable
              handleTemplateAction={handleEditTemplate}
              glTypesData={glTypesData}
              glCategoriesData={glCategoriesData}
            />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default GLTemplate;
